import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoleType } from 'app/shared/models/class/auth/role-type.enum';
import { NavLink } from 'app/shared/models/class/nav/nav-link';
import { User } from 'app/shared/models/class/user/user';
import { UserAnswer } from 'app/shared/models/class/user/userAnswer';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ExportExcelService } from 'app/shared/services/export-excel/export-excel.service';
import { NavService } from 'app/shared/services/nav/nav.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss']
})
export class AdminHomeComponent implements OnInit {
  nav: NavLink[] = [];
  users: User[] = [];
  answers: UserAnswer[] = [];

  isSA:boolean=false;


  constructor(
    private navService: NavService,
    private router: Router,
    private authService: AuthService,
    private exportExcelService: ExportExcelService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.isSA = this.authService.isAuthorized([RoleType.SA]);
    this.initComponent();
  }

  goRedirection(title: string, route: string): void {
    // if (title !== 'Newsletters' ) {
    //   this.router.navigate([route])
    // } else {
    //   this.exportExcel();
    // }
    switch (title) {
      case 'Newsletters':
        this.exportExcel();

        break;
    case 'Answers':
      this.exportExcelAnswers();
        break;
      default:
        this.router.navigate([route])

        break;
    }
    
  }
  private exportExcelAnswers(): void {
    this.userService.getAllAnswers().subscribe({
      next: answers => {
        this.answers = answers;
        this.exportExcelService.exportAsExcelFile(this.answers, 'RamDam_listing_answers');
      }
    });

    
  }

  private exportExcel(): void {

    const excelFile: any[] = [];

    this.users.forEach(user => {

      const infoBooked = {
        'Email': user.email,
        'Newsletter': user.wantsNewsletters ? 'oui' : 'non',

      };
      excelFile.push(infoBooked);
    });

    this.exportExcelService.exportAsExcelFile(excelFile, 'RamDam_listing_newsletter');
  }

  private getAllUser(): void {
    this.userService.getAllUSer().subscribe({
      next: users => this.users = users
    })
  }


  private initComponent(): void {
    if(!this.isSA){
      this.nav = this.navService.navLinks
  
      }else{
        this.nav = this.navService.navLinksSA
        this.getAllUser();
      }
   
    
  }

}
